import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { RateTemplate } from "../_types/rate-template";

@Injectable({
  providedIn: 'root',
})
export class RatesTemplatesService extends Service<RateTemplate> {
  public override type = 'rateTemplates';
  public override url = 'attendance/rateTemplates';

}